'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortDate = exports.formatLongDate = exports.errorDate = exports.catalogCardDate = exports.catalogLongCardDate = undefined;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var momentGuessTZ = function momentGuessTZ(timestamp) {
  return _momentTimezone2.default.unix(timestamp).tz(_momentTimezone2.default.tz.guess());
};

var catalogLongCardDate = exports.catalogLongCardDate = function catalogLongCardDate(timestamp) {
  return momentGuessTZ(timestamp).format('ddd, MMM D, GGGG h:mm A zz');
};

var catalogCardDate = exports.catalogCardDate = function catalogCardDate(timestamp) {
  return momentGuessTZ(timestamp).format('MMM D, GGGG h:mm A zz');
};

var errorDate = exports.errorDate = function errorDate(timestamp) {
  return momentGuessTZ(timestamp / 1000).format('MMMM Do YYYY, h:mm:ss a');
};

var formatLongDate = exports.formatLongDate = function formatLongDate(timestamp) {
  return momentGuessTZ(timestamp).format('MMMM Do, YYYY zz');
};

var formatShortDate = exports.formatShortDate = function formatShortDate(timestamp) {
  return momentGuessTZ(timestamp).format('MMMM Do, YYYY');
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/dates.js
// module id = TbAp
// module chunks = 57